import {
  Component,
  OnInit,
  Input,
  ElementRef,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  Inject
} from '@angular/core';
import {
  fromEvent,
  Subscription,
  Observable
} from 'rxjs';
import {
  tap,
  switchMap,
  takeUntil,
  map,
  filter,
  startWith,
  last,
  finalize
} from 'rxjs/operators';
import {
  SetWindowHeight,
  SetWindowWidth,
} from '../window.actions';
import { WINDOW_CONTAINER_CONTEXT } from '../tokens';
import { Store } from '@ngrx/store';
import { getWindowResizsable } from '../window.selectors';

@Component({
  selector:    'dx-window-resizer',
  templateUrl: './window-resizer.component.html',
  styleUrls:   [ './window-resizer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowResizerComponent implements OnInit, OnDestroy {

  @Input() public containerRef: ElementRef<any>;
  public windowId: string;
  public minWidth: number;
  public minHeight: number;

  @ViewChild('resizer', { static: true }) public resizerRef: ElementRef<any>;

  @Output('width') public width$ = new EventEmitter<string>();
  @Output('height') public height$ = new EventEmitter<string>();
  @Output('resizing') public resizing$ = new EventEmitter<boolean>();

  public resizeable$: Observable<boolean>;

  private _subscription = new Subscription();

  constructor(
    @Inject(WINDOW_CONTAINER_CONTEXT) context: any,
    public store$: Store<any>
  ) {
    this.windowId = context.id;
    this.minHeight = context.minHeight || 100;
    this.minWidth = context.minWidth || 250;
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  ngOnInit() {

    this.resizeable$ = this.store$.select(getWindowResizsable(this.windowId));

    let originalMouseX = 0;
    let originalMouseY = 0;
    let originalWidth  = 0;
    let originalHeight = 0;

    this._subscription.add(
      fromEvent<MouseEvent>(this.resizerRef.nativeElement, 'mousedown').pipe(
        tap(event => {
          this.resizing$.emit(true);
          originalMouseX = event.pageX;
          originalMouseY = event.pageY;
          originalWidth  = parseFloat(
            getComputedStyle(this.containerRef.nativeElement, null)
              .getPropertyValue('width')
              .replace('px', '')
          );
          originalHeight = parseFloat(
            getComputedStyle(this.containerRef.nativeElement, null)
              .getPropertyValue('height')
              .replace('px', '')
          );
        }),
        switchMap(() => fromEvent<MouseEvent>(window, 'mousemove').pipe(
          takeUntil(fromEvent(window, 'mouseup')),
          map((event) => ({
            width:  originalWidth + (event.pageX - originalMouseX),
            height: originalHeight + (event.pageY - originalMouseY),
          })),
          filter(size => this.minHeight <= size.height && this.minWidth <= size.width),
          tap(size => console.log(size)),
          map(size => ({ width: size.width + 'px', height: size.height + 'px' })),
          tap(size => {
            this.width$.emit(size.width);
            this.height$.emit(size.height);
          }),
          map(size => [
            new SetWindowHeight(this.windowId, size.height, 'WindowContainerComponent::resizerRef::mouseup'),
            new SetWindowWidth(this.windowId, size.width, 'WindowContainerComponent::resizerRef::mouseup')
          ]),
          startWith([]),
          last(actions => {
            for(const action of actions) {
              this.store$.dispatch(action);
            }
            return true;
          }),
          finalize(() => this.resizing$.emit(false))
          )
        )
      ).subscribe()
    );

  }

}
